export const getEmbedState = state => state.embed
export const getEmbedOptions = state => state.embed.embedOptions
export const getIsAssignmentEmbed = state => state.embed.isAssignment
